export class AttributeItem {
    constructor(data) {
        this.attributeId = data.attributeId;
        this.attributeTypeDesc = data.attributeTypeDesc;
        this.textValue1 = data.textValue1;
        this.textValue2 = data.textValue2;
        this.numericValue1 = data.numericValue1;
        this.numericValue2 = data.numericValue2;
    }
}